(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slogan-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selector = '[data-animated-slogan]';
    var observer = null;

    function show(section) {
      section.classList.add('as-visible');
    }

    function initialize(scope) {
      if (!scope) return;

      var sections = [];
      if (scope.matches && scope.matches(selector)) sections.push(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll(selector).forEach(function (item) {
          sections.push(item);
        });
      }

      sections.forEach(function (section) {
        if (section.dataset.asInitialized === 'true') return;
        section.dataset.asInitialized = 'true';

        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (section.dataset.animationEnabled !== 'true' || reduceMotion || !('IntersectionObserver' in window)) {
          show(section);
          return;
        }

        section.classList.add('as-waiting');
        if (!observer) {
          observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              show(entry.target);
              observer.unobserve(entry.target);
            });
          }, { threshold: 0.25 });
        }
        observer.observe(section);
      });
    }

    function onReady() { initialize(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady, { once: true });
    } else {
      onReady();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:select', function (event) {
      var node = event.target;
      var section = node.matches && node.matches(selector) ? node : node.querySelector(selector);
      if (section) {
        show(section);
        if (observer) observer.unobserve(section);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!observer) return;
      var node = event.target;
      var section = node.matches && node.matches(selector) ? node : node.querySelector(selector);
      if (section) observer.unobserve(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
